import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-attachment"
export default class extends Controller {
  triggerFileInput(event) {
    const attachmentField = event.target.closest('.auto-attachment-fields')
    const fileInput = attachmentField.querySelector('input[type="file"]')
    if (fileInput) {
      fileInput.click()
    }
  }

  handleFileChange(event) {
    const fileInput = event.target
    const attachmentField = fileInput.closest('.auto-attachment-fields')
    
    if (fileInput.files && fileInput.files.length > 0) {
      const fileName = fileInput.files[0].name
      
      // Update the display to show the selected file name
      const fileNameSpan = attachmentField.querySelector('.file-name')
      const icon = attachmentField.querySelector('.attachment-add-file-link i')
      const removeLink = attachmentField.querySelector('.attachment-remove-link')
      const addFileLink = attachmentField.querySelector('.attachment-add-file-link')
      
      if (fileNameSpan && icon && removeLink && addFileLink) {
        fileNameSpan.textContent = fileName
        icon.className = 'fa fa-regular fa-file' // Change icon to file icon
        removeLink.style.display = 'flex' // Show the X button next to filename
        
        // Remove click event and change styling for attached file
        addFileLink.removeAttribute('data-action')
        addFileLink.style.cursor = 'default'
        addFileLink.style.color = '#2c383f'
        addFileLink.style.textDecoration = 'none'
        addFileLink.style.pointerEvents = 'none'
      }
      
      // Add a new field for the next attachment
      const addButton = this.element.querySelector('.hidden-add-attachment')
      if (addButton) {
        addButton.click()
      }
    }
  }
}
